import { useMediaQuery } from '@mui/material';
import pour from './assets/pour.png';
import hang from './assets/hang.png';
import softbody1 from './assets/softbody1.png';
import softbody2 from './assets/softbody2.png';
import softbody3 from './assets/softbody3.png';
import pandaavoidobstacles from './assets/pandaavoidobstacles.png';
import pinch from './assets/pinch.png';
import pickCube from './assets/pickcube.png';
import plugcharger from './assets/plugcharger.png';
import pickclutter from './assets/pickclutter.png';
import stackcube from './assets/stackcube.png';
import turnfaucet from './assets/turnfaucet.png';
import pickycb from './assets/pickycb.png';
import pickegad from './assets/pickegad.png';
import peginsertion from './assets/peginsertion.png';
import qualcommlogo from './assets/qualcommlogo.png';
import movebucket from './assets/movebucket.png';
import opencabinetdoor from './assets/opencabinetdoor.png';
import opencabinetdrawer from './assets/opencabinetdrawer.png';
import pushchair from './assets/pushchair.png';
import assemblykit from './assets/assemblykit.png';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import { HashLink } from 'react-router-hash-link';
import { Link } from 'react-router-dom';
import fanboxiang from './people/fanboxiang.jpg';
import haosu from './people/haosu.jpg';
import jiayuangu from './people/jiayuangu.png';
import stonetao from './people/stonetao.jpg';
import tongzhoumu from './people/tongzhoumu.jpg';
import xuanlinli from './people/xuanlinli.jpg';
import zhanling from './people/zhanling.jpg';
import xiaodiyuan from './people/xiaodiyuan.jpg';
import xinyue from './people/xinyue.jpg';
import xiqiangliu from './people/xiqiangliu.jpg';
import ruichen from './people/ruichen.jpg';
import zhiaohuang from './people/zhiaohuang.jpg';
import yihetang from './people/yihetang.jpg';
const Content = () => {
  const softTaskImages = [
    { src: softbody2, text: 'Pour' },
    { src: hang, text: 'Hang' },
    { src: pour, text: 'Fill' },
    { src: softbody1, text: 'Write' },
    { src: softbody3, text: 'Excavate' },
    { src: pinch, text: 'Pinch' },
  ];
  const artTaskImages = [
    { src: turnfaucet, text: 'Turn Faucet' },
    { src: pushchair, text: 'Push Chair' },
    { src: opencabinetdoor, text: 'Open Cabinet Door' },
    { src: opencabinetdrawer, text: 'Open Cabinet Drawer' },
    { src: movebucket, text: 'Move Bucket' },
  ];
  const rigidTaskImages = [
    { src: pickclutter, text: 'Pick Clutter' },
    { src: plugcharger, text: 'Plug Charger' },
    { src: pickCube, text: 'Pick Cube' },
    { src: assemblykit, text: 'Assembly Kit' },
    { src: stackcube, text: 'Stack Cube' },
    { src: pickycb, text: 'Pick YCB Object' },
    { src: pickegad, text: 'Pick EGAD Object' },
    { src: peginsertion, text: 'Peg Insertion' },
    { src: pandaavoidobstacles, text: 'pandaavoidobstacles' },
  ];
  const smallSize = useMediaQuery('(max-width: 768px)');
  return (
    <div className="content">
      <section>
        <a id="intro" className="anchor"></a>
        <h2>Welcome to the ManiSkill2 Challenge</h2>
        <p>
          The official ManiSkill2 challenge concluded at the{' '}
          <a href="https://embodied-ai.org/" target="_blank" rel="noreferrer">
            CVPR2023 Embodied AI Workshop
          </a>
          . Congratulations to team GXU-LIPE from Guangxi University for placing
          first on all tracks! See their solution report here: <a href="https://arxiv.org/abs/2307.11343" target="_blank" rel="noreferrer">https://arxiv.org/abs/2307.11343</a>. To see an overview of the challenge results and awardees, see the <Link to="/past-results/maniskill2-challenge">past results here.</Link>
        </p>
        <p>We are still maintaining an ongoing leaderboard that you can submit and benchmark your solutions at any time here: <a href="https://sapien.ucsd.edu/challenges/maniskill/challenges/ms2-ongoing" target="_blank" rel="noreferrer">https://sapien.ucsd.edu/challenges/maniskill/challenges/ms2-ongoing</a></p>
        {/* <p><strong>Moreover, the ManiSkill2 Challenge award ceremony will be held at the <a href="https://ai-workshops.github.io/interdisciplinary-exploration-of-gmpl/" target="_blank" rel="noreferrer">RSS2023 workshop: Interdisciplinary Exploration of Generalizable Manipulation Policy Learning: Paradigms and Debates</a></strong></p> */}
        <p>
          The ManiSkill2 Challenge is a large-scale robotic manipulation
          challenge that seeks to benchmark generalizable robotic agents that
          can interact with the 3D world like we humans do. The challenge
          features diverse objects and diverse task families in{' '}
          <a href="https://sapien.ucsd.edu/" target="_blank" rel="noreferrer">
            SAPIEN
          </a>
          , a fully-physical, realistic simulator. The challenge is based on the
          ICLR 2023{' '}
          <a
            target="_blank"
            rel="noreferrer"
            href="https://arxiv.org/abs/2302.04659"
          >
            ManiSkill2 paper
          </a>
          . For details on the ManiSkill2 benchmark, see the{' '}
          <a
            target="_blank"
            rel="noreferrer"
            href="https://maniskill2.github.io/"
          >
            project page
          </a>
        </p>

        <p>
          <strong>
            Stay up to date by following{' '}
            <a
              target="_blank"
              rel="noreferrer"
              href="https://twitter.com/HaoSuLabUCSD"
            >
              @HaoSuLabUCSD
            </a>{' '}
            on twitter and join our{' '}
            <a
              target="_blank"
              rel="noreferrer"
              href="https://discord.gg/x8yUZe5AdN"
            >
              discord
            </a>
            .
          </strong>
        </p>
        <p>
          We highly recommend you to join our discord in case you have any
          questions, in addition to receiving important competition
          announcements as soon as possible.
        </p>
      </section>
      <section>
        <a id="getting-started" className="anchor"></a>
        <h2>Getting Started</h2>
        <p>
          To get started submitting to the current ongoing challenge, follow these steps:
          <ol>
            <li>
              If you have not registered SAPIEN before, please use this{' '}
              <a href="https://sapien.ucsd.edu/login?redirect=https:%2F%2Fsapien.ucsd.edu">
                link
              </a>{' '}
              to register a SAPIEN account. If you are using a .edu email, you
              will immediately get an email to complete registration. If not,
              you need to wait for our manual confirmation.
            </li>
            <li>
              Once you have a verified SAPIEN account,{' '}
              <Link to="/login">
                you can log into the ManiSkill2 Challenge.
              </Link>
            </li>
            <li>
              Next, you need to create a team in order to make submissions.
              Register your team <Link to="/challenges/ms2-ongoing/team">here</Link> or
              join an existing team by using their invite code (
              <Link to="/challenges">Compete</Link> {'>'}{' '}
              <Link to="/challenges/ms2-ongoing">ManiSkill2 Running Leaderboard</Link> {'>'}{' '}
              <Link to="/challenges/ms2-ongoing/team">Team</Link>).
            </li>
            <li>
              The codebase for this challenge is hosted on{' '}
              <a
                href="https://github.com/haosulab/ManiSkill2"
                rel="noreferrer"
                target="_blank"
              >
                GitHub
              </a>
              . This repository contains information about the competition
              environments, and the submission format.
            </li>
            <li>
              Checkout the leaderboard and make your own submission{' '}
              <Link to="/challenges/ms2">here</Link>.
            </li>
          </ol>
        </p>
      </section>
      <section>
        <div id="features" className="anchor"></div>
        <h2>Features</h2>
        <div>
          <p>The ManiSkill2 challenge brings</p>
          <ul>
            <li>
              20 unique manipulation <HashLink to="#tasks">task</HashLink>{' '}
              families
            </li>
            <li>Rigid and soft-body tasks</li>
            <li>2000+ different objects</li>
            <li>Realistic and contact-rich physical simulation</li>
            <li>
              Fast visual RL support: See the{' '}
              <a
                href="https://maniskill2.github.io/#fast_visual_rl"
                target="_blank"
                rel="noreferrer"
              >
                benchmark graph
              </a>{' '}
              for speed comparisons.
            </li>
            <li>Large-scale demonstrations for every task</li>
          </ul>
          <p>
            Compared to{' '}
            <a
              href="https://sapien.ucsd.edu/challenges/maniskill/2021/"
              target="_blank"
              rel="noreferrer"
            >
              the first ManiSkill Challenge
            </a>
            , there are many more diverse <HashLink to="#tasks">tasks</HashLink>
            , as well as improvements in simulation speed and user interfaces.
            With these new features, we are excited to see what the community
            can build and research!
          </p>
        </div>
      </section>
      <section>
        <a id="tracks" className="anchor"></a>
        <h2>Challenge Tracks</h2>
        <p>
          There are three tracks with awards: Imitation/Reinforcement Learning
          (Rigid Body), No Restriction (Rigid Body), No Restriction (Soft Body).
          Note that when handing out awards the organizing team has
          full-discretion over which track your final submissions fall under.
        </p>
        <ul>
          <li>
            Imitation/Reinforcement Learning (Rigid Body) is for solutions that
            utilize IL and/or RL to solve rigid body environments (including
            articulated body environments).
          </li>
          <li>
            No Restriction (Rigid Body) is an open track that permits any kind
            of solution to solve rigid body environments (including articulated
            body environments).
          </li>
          <li>
            No Restriction (Soft Body) is an open track that permits any kind of
            solution to solve soft body environments.
          </li>
        </ul>
      </section>
      <section>
        <a id="awards" className="anchor"></a>
        <h2>Awards/Sponsors</h2>
        <p>
          Thanks to our sponsors at Qualcomm, there was a $20,000 prize pool
          and authorship based prizes in the ManiSkill2 challenge. Congratulations to team GXU-LIPE from Guangxi University for placing
          first on all tracks! See their solution report here: <a href="https://arxiv.org/abs/2307.11343" target="_blank" rel="noreferrer">https://arxiv.org/abs/2307.11343</a>. To see a overview of all awardees see the <Link to="/past-results/maniskill2-challenge">past results here.</Link>
        </p>
        <p>
          <img src={qualcommlogo} alt="Qualcomm Logo" height="50rem" />
        </p>
        <p>
          Each of the three challenge tracks came with a $6,000 prize pool. The
          prizes are split across the top three teams as follows
        </p>
        <ul>
          <li>1st: $3,000</li>
          <li>2nd: $2,000</li>
          <li>3rd: $1,000</li>
        </ul>
        <p>
          Teams were ranked based on the average success rate across the
          designated tasks in each track after the evaluation period (see{' '}
          <a href="#evaluation">Evaluation</a> for specific details.)
        </p>
        <p>
          The remaining $2,000 in prizes are distributed out as special
          awards for underrepresented teams with strong results.
        </p>
        <p>
          For the rigid-body tracks, in order to qualify for potential rewards,
          the final submission must have non-zero success on at least 4 tasks
          after evaluation or the average success across all 12 tasks must
          exceed 10%. For the soft-body track, your final submission must have
          non-zero success on at least 2 tasks after evaluation or or the
          average success across all 6 tasks must exceed 10%.
        </p>
      </section>
      {/* <section>
        <a id="timeline" className="anchor"></a>
        <h2>Timeline</h2>
        <ul>
          <li>July 14, 2022: Registration opens</li>
          <li>
            March 15, 2023: Challenge releases, stage 1 of evaluation begins
          </li>
          <li>
            June 12th, 2023: Submission deadline, stage 2 of evaluation begins
          </li>
          <li>Mid-June, 2023: Results are Announced</li>
        </ul>
      </section> */}
      {/* <section>
        <a id="teams" className="anchor"></a>
        <h2>Team Formation</h2>
        <p>
          For the challenge, you must{' '}
          <Link to="/challenges/ms2/team">create/join a team</Link> in order to
          make submissions. All submissions made by any team member will show up
          on their team page. You may not create multiple accounts / join
          multiple teams. Doing so may result in a ban from this competition and
          make you ineligible for awards.
        </p>
      </section> */}
      <section>
        <a id="evaluation" className="anchor"></a>
        <h2>Evaluation</h2>
        <p>
          Each submission contains a user submitted docker URL as well as the
          tasks the user wishes to evaluate on. Each task evaluation is given 1
          single 2080Ti GPU, 10CPU threads, and 50GB RAM.
        </p>
        <p>
          Each task evaluation consists of running a user's programmed policy in
          their docker image over a number of episodes. The episode
          configurations for each task are described in detail on our{' '}
          <a
            href="https://haosulab.github.io/ManiSkill2/concepts/environments.html"
            target="_blank"
            rel="noreferrer"
          >
            documentation
          </a>
          .
        </p>
        <p>
          Public leaderboard results will show aggregated metrics, picking out
          the highest success rate in each metric across all of your team's past
          submissions (which can be filtered by submission track). In order to
          ensure reproducibility, we enforce all submitted docker images to be
          uniquely tagged.
        </p>
        {/* <p>
          Overall there are two stages used to evaluate the rankings of all
          teams in each track. The score for each stage is the average success
          rate across all tasks in a track. The success rate for a task is the
          highest success rate achieved across all of your team's submissions
          for that track. See the <a href="#tasks">Tasks</a> section to see
          which tasks are used for the evaluation.
        </p>
        <p>
          <strong>Stage 1:</strong> Submissions are open and teams may submit
          any number of times to evaluate on any number of available tasks.
          Teams are given a budget of 50 tasks each day, reset every day at
          8:00AM UTC. Importantly, in order to submit to stage 2, for each track
          teams must select up to 14 submissions to use for final evaluation in
          stage 2 through their{' '}
          <Link to="/challenges/ms2/team">team page.</Link> For teams that do
          not explicitly select submissions for final evaluation, we will use
          the current leaderboard test results to infer which submission
          achieves the highest average success rate and evaluate that
          submission. We recommend you dedicating one submission per task (there
          are a max of 14 tasks in a track).
        </p>
        <p>
          <strong>Stage 2:</strong> Submissions are closed and we begin the
          final evaluation to compute stage 2 scores. Similar to stage 1, we
          will use your best success rates for each task out of your final
          submissions in a track. The final score for awards and rankings is
          computed as the average of stage 1 and stage 2.
        </p> */}
      </section>
      <section>
        <a id="tasks" className="anchor"></a>
        <h2>Tasks</h2>
        <p>
          For more detailed information on the environments such as train/test
          evaluation configurations and environment specifics, check out the{' '}
          <a
            href="https://haosulab.github.io/ManiSkill2/concepts/environments.html#rigid-body"
            rel="noreferrer"
            target="_blank"
          >
            Rigid Body Environments
          </a>{' '}
          and{' '}
          <a
            href="https://haosulab.github.io/ManiSkill2/concepts/environments.html#soft-body"
            rel="noreferrer"
            target="_blank"
          >
            Soft Body Environments
          </a>{' '}
          wiki pages. Make sure to join our{' '}
          <a
            href="https://discord.gg/x8yUZe5AdN"
            target="_blank"
            rel="noreferrer"
          >
            discord
          </a>{' '}
          to be up to date on announcements about the competition.
        </p>
        <p>
          {' '}
          For the challenge awards, the rigid-body tracks will use the average
          success rates over the following 12 tasks: StackCube, PickSingleYCB,
          PickSingleEGAD, PickClutterYCB, PegInsertionSide, PlugCharger,
          AssemblingKits, TurnFaucet, OpenCabinetDoor, OpenCabinetDrawer,
          PushChair, MoveBucket. (Excluded tasks are: PickCube,
          PandaAvoidObstacles). The soft-body track will use all 6 tasks.
        </p>
        <h3>Soft-body tasks</h3>
        {/* <Grid container spacing={2} className="example-tasks">
        {taskImages.map((data, idx) => {
          return (
            <Grid item xs={6} md={4} key={`img-${idx}`}>
                <img src={data.src} />
            </Grid>
          );
        })}

      </Grid> */}
        <Carousel autoPlay showArrows={true} className="example-tasks">
          {softTaskImages.map((data, idx) => {
            return (
              <div className="image-wrapper" key={`soft-task-${idx}`}>
                <img src={data.src} alt={data.text} />
                <p className="legend">{data.text}</p>
              </div>
            );
          })}
        </Carousel>
        <h3>Rigid-body tasks</h3>
        <Carousel autoPlay showArrows={true} className="example-tasks">
          {rigidTaskImages.map((data, idx) => {
            return (
              <div className="image-wrapper" key={`rigid-task-${idx}`}>
                <img
                  src={data.src}
                  alt={data.text}
                  style={{ objectPosition: 'bottom' }}
                />
                <p className="legend">{data.text}</p>
              </div>
            );
          })}
        </Carousel>
        <h3>Articulation tasks (part of rigid-body track)</h3>
        <Carousel
          autoPlay
          showArrows={true}
          className="example-tasks articulation-tasks"
        >
          {artTaskImages.map((data, idx) => {
            return (
              <div className="image-wrapper" key={`art-task-${idx}`}>
                <img src={data.src} alt={data.text} />
                <p className="legend">{data.text}</p>
              </div>
            );
          })}
        </Carousel>
      </section>
      <section>
        <a id="resources" className="anchor"></a>
        <h2>Resources/Tutorials</h2>
        <p>
          We have provided some quick Colab notebooks for a{' '}
          <a
            target="_blank"
            rel="noreferrer"
            href="https://colab.research.google.com/github/haosulab/ManiSkill2/blob/main/examples/tutorials/1_quickstart.ipynb"
          >
            quickstart on using ManiSkill2
          </a>{' '}
          and{' '}
          <a
            target="_blank"
            rel="noreferrer"
            href="https://github.com/haosulab/ManiSkill2/tree/main/examples/tutorials"
          >
            tutorials on RL, IL, and environment customization
          </a>
          .
        </p>
        <p>
          Documentation can be found{' '}
          <a
            target="_blank"
            rel="noreferrer"
            href="https://haosulab.github.io/ManiSkill2/"
          >
            here
          </a>
        </p>
        <p>
          For some recommended tips and tutorials on tackling the ManiSkill
          Challenge, we recommend looking at the{' '}
          <HashLink to="#maniskill2021">ManiSkill 2021 results.</HashLink> We
          further recommend using our RL library,{' '}
          <a
            href="https://github.com/haosulab/ManiSkill2-learn"
            rel="noreferrer"
            target="_blank"
          >
            ManiSkill2-Learn
          </a>{' '}
          specifically designed to tackle the Maniskill challenge. This includes
          a number of popular algorithms such as Demonstration-Augmented Policy
          Gradient (DAPG) and Soft Actor-Critic (SAC), as well as inverse-RL
          methods such as Generative-Adversarial Imitation Learning (GAIL).
          {/* <a href="" target="_blank" rel="noreferrer">
            our wiki page
          </a> */}
        </p>
        <p>
          If you want to learn how to use, debug, and modify maniskill
          environments, checkout the{' '}
          <a
            href="https://ai-workshops.github.io/building-and-working-in-environments-for-embodied-ai-cvpr-2022/"
            target="_blank"
            rel="noreferrer"
          >
            CVPR 2022 Tutorial
          </a>{' '}
          on Building and Working in Environments for Embodied AI.
        </p>
      </section>
      <section>
        <a id="maniskill2021" className="anchor"></a>
        <h2>ManiSkill 2021</h2>
        <p>
          The{' '}
          <a
            href="https://sapien.ucsd.edu/challenges/maniskill/2021/"
            target="_blank"
            rel="noreferrer"
          >
            ManiSkill 2021 challenge
          </a>{' '}
          concluded on Jan. 21, 2022. We created an affiliated workshop to
          discuss the results and what we learned from last year's challenge at
          ICLR 2022. See the{' '}
          <a
            href="https://ai-workshops.github.io/generalizable-policy-learning-in-the-physical-world/"
            target="_blank"
            rel="noreferrer"
          >
            workshop page
          </a>{' '}
          and our{' '}
          <a
            href="https://arxiv.org/abs/2107.14483"
            target="_blank"
            rel="noreferrer"
          >
            paper
          </a>{' '}
          for more details.
        </p>
        <p>
          The open-sourced code and results from last year can be found{' '}
          <a
            href="https://sapien.ucsd.edu/challenges/maniskill/2021/result"
            target="_blank"
            rel="noreferrer"
          >
            here
          </a>
          . To read technical reports from participants last year and learn how
          they competed successfully in last year's challenge, follow the links
          below
        </p>
        <ul>
          <li>
            <a
              href="https://openreview.net/forum?id=BN3b2VpE1Wc"
              target="_blank"
              rel="noreferrer"
            >
              A Minimalist Ensemble Method for Generalizable Offline Deep
              Reinforcement Learning
            </a>
          </li>
          <li>
            <a
              href="https://openreview.net/forum?id=SObVnEp4yb9"
              target="_blank"
              rel="noreferrer"
            >
              Let's Handle It: Generalizable Manipulation of Articulated Objects
            </a>
          </li>
          <li>
            <a
              href="https://openreview.net/forum?id=STfl2VTNy-9"
              target="_blank"
              rel="noreferrer"
            >
              An Empirical Study and Analysis of Learning Generalizable
              Manipulation Skill in the SAPIEN Simulator
            </a>
          </li>
          <li>
            <a
              href="https://openreview.net/forum?id=rNhxaETVybc"
              target="_blank"
              rel="noreferrer"
            >
              Silver-Bullet-3D at ManiSkill 2021: Learning-from-Demonstrations
              and Heuristic Rule-based Methods for Object Manipulation
            </a>
          </li>
          <li>
            <a
              href="https://openreview.net/forum?id=SNnLCV6NyW9"
              target="_blank"
              rel="noreferrer"
            >
              Learning Category-Level Generalizable Object Manipulation Policy
              via Generative Adversarial Self-Imitation Learning from
              Demonstrations
            </a>
          </li>
          <li>
            <a
              href="https://openreview.net/forum?id=SdWOpNTVJZc"
              target="_blank"
              rel="noreferrer"
            >
              Improving performance on the ManiSkill Challenge via
              Super-convergence and Multi-Task Learning
            </a>
          </li>
        </ul>
        <p>
          To learn about how others have utilized the ManiSkill 2021 benchmark
          for research, see these published works
        </p>
        <ul>
          <li>
            <a
              href="https://arxiv.org/abs/2203.02107"
              target="_blank"
              rel="noreferrer"
            >
              Learning Category-Level Generalizable Object Manipulation Policy
              via Generative Adversarial Self-Imitation Learning from
              Demonstrations
            </a>
          </li>
          <li>
            <a
              href="https://arxiv.org/abs/2205.04382"
              target="_blank"
              rel="noreferrer"
            >
              FlowBot3D: Learning 3D Articulation Flow to Manipulate Articulated
              Objects
            </a>
          </li>
        </ul>
      </section>
      <section>
        <div id="organizers" className="anchor"></div>
        <h2>Organizers</h2>
        <div className="person">
          <img src={jiayuangu} />
          <div>Jiayuan Gu</div>
          <div className="aff">UC San Diego</div>
        </div>
        <div className="person">
          <img src={fanboxiang} />
          <div>Fanbo Xiang</div>
          <div className="aff">UC San Diego</div>
        </div>
        <div className="person">
          <img src={ruichen} />
          <div>Rui Chen</div>
          <div className="aff">Tsinghua University</div>
        </div>
        <div className="person">
          <img src={stonetao} />
          <div>Stone Tao</div>
          <div className="aff">UC San Diego</div>
        </div>
        <div className="person">
          <img src={haosu} />
          <div>Hao Su</div>
          <div className="aff">UC San Diego</div>
        </div>
      </section>
      <section>
        <div id="contributors" className="anchor"></div>
        <h2>Contributors</h2>
        <h3>Soft body environments</h3>
        <div className="person">
          <img src={xinyue} />
          <div>Xinyue Wei</div>
          <div className="aff">UC San Diego</div>
        </div>

        <div className="person">
          <img src={yihetang} />
          <div>Yihe Tang</div>
          <div className="aff">UC San Diego</div>
        </div>
        <div className="person">
          <img src={xiaodiyuan} />
          <div>Xiaodi Yuan</div>
          <div className="aff">Tsinghua University</div>
        </div>
        <div className="person">
          <img src={zhiaohuang} />
          <div>Zhiao Huang</div>
          <div className="aff">UC San Diego</div>
        </div>
        <h3>Rigid body environments</h3>
        <div className="person">
          <img src={xiqiangliu} />
          <div>Xiqiang Liu</div>
          <div className="aff">UC San Diego</div>
        </div>
        <div className="person">
          <img src={tongzhoumu} />
          <div>Tongzhou Mu</div>
          <div className="aff">UC San Diego</div>
        </div>
        <h3>Infrastructure and Experiments</h3>
        <div className="person">
          <img src={zhanling} />
          <div>Zhan Ling</div>
          <div className="aff">UC San Diego</div>
        </div>
        <div className="person">
          <img src={xuanlinli} />
          <div>Xuanlin Li</div>
          <div className="aff">UC San Diego</div>
        </div>
      </section>
      <section id="citation">
        <h2>Citation</h2>
        <p>If you use our work in your research please cite the following</p>
        <pre>{`@inproceedings{gu2023maniskill2,
  title={ManiSkill2: A Unified Benchmark for Generalizable Manipulation Skills},
  author={Gu, Jiayuan and Xiang, Fanbo and Li, Xuanlin and Ling, Zhan and Liu, Xiqiang and Mu, Tongzhou and Tang, Yihe and Tao, Stone and Wei, Xinyue and Yao, Yunchao and Yuan, Xiaodi and Xie, Pengwei and Huang, Zhiao and Chen, Rui and Su, Hao},
  booktitle={International Conference on Learning Representations},
  year={2023}
}`}</pre>
      </section>
      <section>
        <div id="contact" className="anchor"></div>
        <h2>Contact Us</h2>
        <p>
          Follow{' '}
          <a
            target="_blank"
            rel="noreferrer"
            href="https://twitter.com/HaoSuLabUCSD"
          >
            @HaoSuLabUCSD
          </a>{' '}
          on twitter and/or join our{' '}
          <a
            target="_blank"
            rel="noreferrer"
            href="https://discord.gg/x8yUZe5AdN"
          >
            discord
          </a>{' '}
          to contact us. You may also email us at{' '}
          <a
            href="mailto:maniskill2022@gmail.com"
            target="_blank"
            rel="noreferrer"
          >
            maniskill2022@gmail.com
          </a>
        </p>
      </section>
    </div>
  );
};
export default Content;
